import { requestService } from 'shared/utils/services/requestService';

export const fetchUserProductIdOffer = (productId: string) =>
  requestService({
    url: `/web-api/v1/wants/find_offer?productId=${productId}`,
    method: 'get',
  });
